import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { getProductIcon } from 'src/app/types/product-type-icon.map';
import { ProductOptionsModalComponent } from '../../modals/product-options-modal/product-options-modal.component';
@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss'],
  standalone: false
})
export class ProductItemComponent implements OnInit {

  @Input() product: any;
  @Input() dropdownOpenId: number | null = null;
  @Input() isTicketSold: boolean = false;
  @Input() eventId: string | number | null = null;
  @Output() toggleDropdown = new EventEmitter<number | null>();
  @Output() seeTicketSoldInfo = new EventEmitter<number>();
  @Output() productDetailsRequested = new EventEmitter<any>();

  public icon: string = '';

  constructor(
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.icon = getProductIcon(this.product?.product_type);
  }

  get isDropdownOpen(): boolean {
    return this.dropdownOpenId === this.product.id;
  }

  onToggleDropdownClick(event: MouseEvent) {
    event.stopPropagation();
    this.onToggleDropdown();
  }

  onToggleDropdown() {
    this.toggleDropdown.emit(this.isDropdownOpen ? null : this.product.id);
  }

  select() {
    this.productDetailsRequested.emit(this.product);
  }

  onSeeTicketSoldInfo() {
    this.seeTicketSoldInfo.emit(this.product.id);
  }

  async openProductOptionsModal() {
    const modal = await this.modalCtrl.create({
      component: ProductOptionsModalComponent,
      componentProps: { 
        product: this.product, 
        isTicketSold: this.isTicketSold,
        eventId: this.eventId
      },
      breakpoints: [0, 0.5, 0.95],
      initialBreakpoint: 0.25,
      cssClass: 'product-options-modal',
      handle: true
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data?.action === 'details') {
      this.select();
    }
  }


}
